import React, { createContext, useContext, useState, useCallback } from "react";
import Snackbar from "../Snackbar";
const ToastContext = createContext();

export const useToast = () => useContext(ToastContext);

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({
    open: false,
    message: "",
    severity: "info", // "success", "error", "warning"
  });

  const showToast = useCallback((message, severity = "info", duration = 3000) => {
    setToast({ open: true, message, severity });
    if (duration > 0) {
      setTimeout(() => {
        setToast((prev) => ({ ...prev, open: false }));
      }, duration);
    }
  }, []);

  const handleClose = useCallback(() => {
    setToast((prev) => ({ ...prev, open: false }));
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <Snackbar
        open={toast.open}
        message={toast.message}
        severity={toast.severity}
        onClose={handleClose}
        className="shadow-lg"
      />
    </ToastContext.Provider>
  );
};
